// These must be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

/**
 * Base modules import
 */
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
// import * as Sentry from '@sentry/browser';
import App from './App';
import store from './store';

/**
 * Styles import
 */
import './index.scss';
import 'react-toastify/dist/ReactToastify.min.css';

// Sentry.init({
//   dsn: "https://8ec67fb309244df49eb53387ec3c4a11@sentry.io/1324632"
// });

// const originConsoleError = console.error;
// console.error = (...error) => {
//   originConsoleError(...error);

//   Sentry.captureException(error);
// };

render(
  <Provider store={store}>
    <App/>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js